import React, { useState, useEffect } from "react";
import { Container, Box, TextField, Button, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { db ,collection, getDocs } from "../../firebase"; 
import { query, where } from "firebase/firestore";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [adminUser, setAdminUser] = useState("");
  const navigate = useNavigate(); 

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        console.log("Fetching admin user from Firestore...");
        const q = query(collection(db, "user"), where("isAdmin", "==", true));
        console.log("qq",q)
        const querySnapshot = await getDocs(q);
        
        console.log("Query executed. Number of admin users found:", querySnapshot.docs.length);
        
        if (!querySnapshot.empty) {
          const adminData = querySnapshot.docs[0].data();
          console.log("Admin user data from Firestore:", adminData);

          console.log("user",adminData.email,adminData.password)

          setAdminUser({
            email: adminData.email,
            password: adminData.password, // Ensure password is hashed in a real application
          });
        } else {
          console.error("No admin user found in Firestore.");
        }
      } catch (error) {
        console.error("Error fetching admin data: ", error);
      }
    };

    fetchAdmin();
  }, []);

  const handleLogin = async () => {
    setError("");

    console.log("User input email:", email);
    console.log("User input password:", password);
    
    if (!adminUser) {
      console.error("Admin user is still null. Fetching failed?");
      setError("Admin user not found.");
      return;
    }


    console.log("Stored admin email:", adminUser.email);
    console.log("Stored admin password:", adminUser.password);

    if (email !== adminUser.email || password !== adminUser.password) {
      console.error("Incorrect email or password entered.");
      setError("Unauthorized user. Access denied.");
      return;
    }else{
      console.log("Login successful! Redirecting...");
      localStorage.setItem("isAuthenticated", "true");
      navigate("/"); // Redirect to dashboard after login
    }

    try {
      console.log("Attempting Firebase authentication...");
      await signInWithEmailAndPassword(db, email, password);
      console.log("Login successful! Redirecting...");
      navigate("/"); // Redirect to dashboard after login
    } catch (err) {
      console.error("Firebase authentication failed:", err);
      setError("Invalid email or password");
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#000", 
      }}
    >
      <Container
        maxWidth="xs"
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: "#4b4e54", 
          boxShadow: 3,
        }}
      >
        <Typography variant="h4" color="white" align="center" gutterBottom>
          Admin Login
        </Typography>
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputLabelProps={{ style: { color: "#fff" } }}
          InputProps={{ style: { color: "#fff" } }}
        />
        <TextField
          fullWidth
          label="Password"
          type="password"
          variant="outlined"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputLabelProps={{ style: { color: "#fff" } }}
          InputProps={{ style: { color: "#fff" } }}
        />
        {error && (
          <Typography color="error" align="center">
            {error}
          </Typography>
        )}
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 2, backgroundColor: "#4CAF50", color: "#fff" }}
          onClick={handleLogin}
        >
          Login
        </Button>
        <Box textAlign="center" mt={2}>
          <Link href="#" color="#fff" underline="hover">
            Forgot Password?
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
